import { useState } from 'react';
import { useCustomersApi } from './useCustomersApi';

export const useCustomers = () => {
  const [searchQuery, setSearchQuery] = useState<string>('');

  const { customers, fetchMoreCustomers, isLoading } = useCustomersApi({
    searchQuery
  });

  return {
    customers: customers || [],
    isLoading,
    searchCustomers: setSearchQuery,
    fetchMoreSearchResults: fetchMoreCustomers,
    searchQuery
  };
};
